import {Component, forwardRef, Input, OnInit, ChangeDetectionStrategy} from '@angular/core';

import {ProductService} from '../../../services/product/product.service';
import {Product} from '../../../models/product';
import {forkJoin} from 'rxjs';
import {ControlValueAccessor, FormsModule, NG_VALUE_ACCESSOR} from '@angular/forms';
import {ProductPriority} from '../../../models/product-priority/product-priority';
import {ProductPriorityService} from '../../../services/product-priority/product-priority.service';

@Component({
  selector: 'app-product-priority-selector',
  imports: [
    FormsModule
],
  templateUrl: './product-priority-selector.component.html',
  styleUrl: './product-priority-selector.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => ProductPrioritySelectorComponent),
      multi: true
    }
  ]
})
export class ProductPrioritySelectorComponent implements ControlValueAccessor, OnInit {

  @Input() lang: string | null = null;
  @Input() priorityList: boolean = true;
  @Input() selectMode: boolean = false;

  mode = 'none';
  value: string | null = null;
  componentId: string = '';

  static componentUniqueId = 0;
  static preloaded = false;
  static products: Product[] = [];
  static productPriorities: ProductPriority[] = [];

  constructor(
    private productService: ProductService,
    private productPriorityService: ProductPriorityService
  ) {
    ProductPrioritySelectorComponent.componentUniqueId++
    this.componentId = 'product-priority-selector-' + ProductPrioritySelectorComponent.componentUniqueId.toString();
  }

  ngOnInit(): void {
    if (!ProductPrioritySelectorComponent.preloaded) {
      ProductPrioritySelectorComponent.preloaded = true;

      forkJoin([
        this.productService.findAll({sort: 'name', enabled: true}),
        this.productPriorityService.findAll({sort: 'name'})
      ]).subscribe(([products, productPriorities]) => {
        ProductPrioritySelectorComponent.products = products;
        ProductPrioritySelectorComponent.productPriorities = productPriorities;
      });
    }
  }

  getProducts(): Product[] {
    return ProductPrioritySelectorComponent.products.filter((product: Product) => !this.lang || product.languages.includes(this.lang));
  }

  getProductPriorities(): ProductPriority[] {
    return ProductPrioritySelectorComponent.productPriorities;
  }

  isModeProduct(): boolean {
    return this.mode === 'product';
  }

  isModeList(): boolean {
    return this.mode === 'list';
  }

  writeValue(obj: any): void {
    const value: string = String(obj);

    if (value.startsWith('auto-')) {
      this.mode = 'list';
      this.value = value.substring(5);
    } else if (value.length > 0 && value !== 'null') {
      this.mode = 'product';
      this.value = value;
    } else {
      this.mode = 'none';
      this.value = null;
    }
  }

  onChange = (_: any) => {
  };

  onBlur = (_: any) => {
  }

  registerOnChange(fn: (_: any) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onBlur = fn;
  }

  onModeChanged(): void {
    this.value = null;
    this.onChanged();
  }

  onChanged(): void {
    switch (this.mode) {
      case 'none':
        this.onChange(null);
        break;
      case 'product':
        this.onChange(this.value || null);
        break;
      case 'list':
        this.onChange(this.value ? 'auto-' + this.value : null);
        break;
    }
  }
}
